import * as React from 'react';
import { Route, Switch } from 'react-router';
import Page404 from '../404';
import UsersPanel from './UsersPanel';
import ValidatorUsage from './ValidatorUsage';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

const AdminPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: transparent;
  flex: 2;
  margin: 0 5em 4em;
  min-height: calc(100vh - 80px);
`;

const TopBar = styled.header`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-bottom: 1.25rem;
  padding: 12px 5em;
  box-sizing: border-box;
  background: rgba(7, 10, 13, 0.45);
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
`;

const AdminTabs = styled.nav`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const AdminTabLink = styled(Link)<{ $active?: boolean; $dot: string }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  transition: color 0.15s ease, background 0.15s ease;
  color: ${(p) => (p.$active ? '#f8fafc' : '#94a3b8')};
  background: ${(p) => (p.$active ? 'rgba(51, 65, 85, 0.95)' : 'transparent')};
  border: none;
  box-shadow: ${(p) => (p.$active ? 'inset 0 1px 0 rgba(255, 255, 255, 0.06)' : 'none')};

  &:hover {
    color: #e2e8f0;
    background: ${(p) => (p.$active ? 'rgba(51, 65, 85, 0.95)' : 'rgba(148, 163, 184, 0.08)')};
  }

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${(p) => p.$dot};
  }
`;

const BodyContent = styled.div`
  background: rgba(10, 10, 12, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  color: #e2e8f0;
  padding: 1rem 1.25rem;
`;

const AdminPanel: React.FC = () => {
  const location = useLocation();

  const showAdminTopBar = location.pathname !== '/admin/validatorUsage';

  return (
    <AdminPanelContainer>
      {showAdminTopBar && (
        <TopBar>
          <AdminTabs>
            <AdminTabLink to="/admin/users" $active={location.pathname === '/admin/users'} $dot="#2dd4bf">
              Manage Users
            </AdminTabLink>
            <AdminTabLink
              to="/admin/validatorUsage"
              $active={location.pathname === '/admin/validatorUsage'}
              $dot="#facc15"
            >
              Validator Usage
            </AdminTabLink>
          </AdminTabs>
        </TopBar>
      )}
      <Switch>
        <Route path="/admin" exact component={() => <BodyContent>Nothing to see here.</BodyContent>} />
        <Route path="/admin/users" exact component={UsersPanel} />
        <Route path="/admin/validatorUsage" exact component={ValidatorUsage} />
        <Route component={Page404} />
      </Switch>
    </AdminPanelContainer>
  );
};

export default AdminPanel;
